import { Type } from "class-transformer";
import { DriveItemDTO } from "./item";
import { IsBoolean, IsIn, IsMongoId, IsObject, IsOptional, IsString } from "class-validator";

export class DriveCreateInputDTO {
	@IsString()
	parentID: string;

	@IsString()
	itemName: string;

	@IsIn(['folder', 'file'])
	@IsString()
	type: 'folder' | 'file';

	@IsOptional()
	@IsString()
	ext?: string;

	@IsOptional()
	@IsObject()
	meta?: {};
}

export class DriveCreateOutDTO {
	@IsBoolean()
	success: boolean;

	@IsOptional()
	@IsObject()
	errors?: {
		duplicate: boolean
	}

	@IsOptional()
	@Type(() => DriveItemDTO)
	item?: DriveItemDTO
}